export default __webpack_public_path__ + "static/media/visa.788216cc.svg";